import ParentItem from './ParentItem';

export default ParentItem;
